const ERROR_MESSAGE = event => `Error on creating tracking structure for event: ${event}.`;
const requiredParams = (data, {
  REQUIRED,
  event
}) => {
  const keys = Object.keys(data);
  const missingParams = REQUIRED.filter(required => !keys.includes(required));
  const {
    length
  } = missingParams;
  if (length) {
    const message = [ERROR_MESSAGE(event), `Key${length === 1 ? '' : 's'}:`, missingParams.join(', '), `${length === 1 ? 'is' : 'are'} required`].join(' ');
    throw new Error(message);
  }
};
const validateParam = ({
  param,
  RULES,
  paramName,
  event
}) => {
  if (param && !RULES.includes(param)) {
    const message = [ERROR_MESSAGE(event), `The ${paramName} ${param} is not allowed.`, `The ones allowed are: ${RULES.join(', ')}`].join(' ');
    throw new TypeError(message);
  }
  return true;
};
const subject = ({
  subject: param
}, {
  SUBJECTS: RULES,
  event
}) => {
  validateParam({
    param,
    RULES,
    event,
    paramName: 'subject'
  });
};
const action = ({
  action: param
}, {
  ACTIONS: RULES,
  event
}) => {
  validateParam({
    param,
    RULES,
    event,
    paramName: 'action'
  });
};
const validateSchema = (data, rules, event) => {
  const {
    REQUIRED = [],
    SUBJECTS = [],
    ACTIONS = []
  } = rules;
  if (REQUIRED.length) requiredParams(data, {
    REQUIRED,
    event
  });
  if (SUBJECTS.length) subject(data, {
    SUBJECTS,
    event
  });
  if (ACTIONS.length) action(data, {
    ACTIONS,
    event
  });
};
var validateSchema$1 = validateSchema;

export { validateSchema$1 as default };
